export var AccountRejectedIA = function AccountRejectedIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REJECTED_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REJECTED_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REJECTED_TITLE = function ACCOUNT_REJECTED_TITLE(strictLocalize) {
  return strictLocalize({
    id: "SQcNcq",
    defaultMessage: [{
      "type": 0,
      "value": "Rejeição de conta"
    }]
  });
};
var ACCOUNT_REJECTED_DESCRIPTION = function ACCOUNT_REJECTED_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x0nDyC",
    defaultMessage: [{
      "type": 0,
      "value": "Infelizmente, de momento, não podemos criar a sua conta na Faire. Todas as encomendas pendentes serão canceladas. Se alguma encomenda já tiver sido enviada, os seus pagamentos serão emitidos em conformidade. De momento, não é possível fornecer mais detalhes. Lamentamos qualquer incómodo, mas agradecemos a sua compreensão."
    }]
  });
};